import React from 'react'
import {graphql} from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import {config, animated, useSpring} from 'react-spring'

import Layout from '../components/layout'
import GridItem from '../components/grid-item'
import SEO from '../components/SEO'

export type ChildImageSharp = {
  childImageSharp: {
    fluid: {
      aspectRatio: number
      src: string
      srcSet: string
      sizes: string
      base64: string
      tracedSVG: string
      srcWebp: string
      srcSetWebp: string
    }
  }
}

type PageProps = {
  data: {
    products: {
      nodes: {
        title: string
        slug: string
        cover: ChildImageSharp
      }[]
    }
  }
}

const Area = styled(animated.div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 50vw;

  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    grid-template-columns: 1fr;
    grid-auto-rows: 60vw;
  }
`

const Title = styled.span`
  color: #45567c !important;
`

const Products: React.FunctionComponent<PageProps> = ({data: {products}}) => {
  const pageAnimation = useSpring({
    config: config.slow,
    from: {opacity: 0},
    to: {opacity: 1},
  })

  return (
    <Layout>
      <SEO title="Products" />
      <Area style={pageAnimation}>
        {products.nodes.map((product) => (
          <>
            <GridItem
              key={product.slug}
              to={product.slug}
              aria-label={`View product "${product.title}"`}
            >
              <Img fluid={product.cover.childImageSharp.fluid} />
              <Title>{product.title}</Title>
            </GridItem>
          </>
        ))}
      </Area>
    </Layout>
  )
}

export default Products

export const query = graphql`
  query Products {
    products: allProductsYaml {
      nodes {
        title
        slug
        cover {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
